import React from "react";

import { useLocation } from "@gatsbyjs/reach-router";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import { storageLocal } from "../../../../utils/StorageHandler";
import { getUrlParam } from "../../../../utils/urlParams";
import LinkComponent from "../../LinkComponent";
import { HeaderContainer } from "./../index";

const ChangeButton = styled.div`
    color: ${({ theme }) => theme.colors.red.toString()}!important;
    display: flex;
    justify-content: center;
    padding: 0.25em;
    margin-bottom: 1em;
    font-size: 1rem;
    text-decoration: underline;
    &:hover {
        cursor: pointer;
    }
`;

const Link = styled(LinkComponent)`
    text-underline-offset: 0.33em;
    color: ${({ theme }) => theme.colors.blue.toString()}!important;
    user-select: none;
    -webkit-tap-highlight-color: transparent; /* Safari */
    -webkit-touch-callout: none;
    &:hover {
        color: ${({ theme }) => theme.colors.blue.toString()}!important;
    }
`;

const WebViewTabHeader = ({ hideChangeData, onClickChangeData }) => {
    const location = useLocation();
    const theme = useTheme();

    const activeTabStyle = css`
        color: ${theme.colors.red.toString()}!important;
        text-decoration: underline;
        user-select: none;
        -webkit-tap-highlight-color: transparent; /* Safari */
        -webkit-touch-callout: none;
        &:active,
        &:hover,
        &:focus {
            color: ${theme.colors.red.toString()}!important;
        }
    `;

    return (
        <>
            <HeaderContainer>
                <Link
                    fontSize="1.5rem"
                    css={
                        location.pathname.includes("/heizoel")
                            ? activeTabStyle
                            : null
                    }
                    link={{
                        href: "/webview/heizoel",
                        text: "Heizöl",
                    }}
                />

                <Link
                    fontSize="1.5rem"
                    css={
                        location.pathname.includes("/holzpellets")
                            ? activeTabStyle
                            : null
                    }
                    link={{
                        href: "/webview/holzpellets",
                        text: "Pellets",
                    }}
                />
            </HeaderContainer>
            {!hideChangeData && (
                <ChangeButton onClick={onClickChangeData}>
                    Eingaben ändern
                </ChangeButton>
            )}
        </>
    );
};

/**
 * Determinate if the switchable tab should be shown by the parameter and set it in the localStorage
 */
export const setWebViewTabHeaderVisible = () => {
    const withTabs = getUrlParam("withTabs");
    if (storageLocal.get("webview:calculators-with-tabs")) {
        if (withTabs === "false") {
            storageLocal.remove("webview:calculators-with-tabs");
        }
    }
    if (withTabs === "true") {
        storageLocal.set("webview:calculators-with-tabs", true);
    }
};

export default WebViewTabHeader;
